"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
var __1 = require("..");
var Query = /** @class */ (function () {
    function Query(filter, entityManager) {
        if (entityManager === void 0) { entityManager = __1.EntityManager.instance; }
        this._filter = filter;
        this._entityManager = entityManager;
    }
    Object.defineProperty(Query.prototype, "getFilter", {
        get: function () {
            return this._filter;
        },
        enumerable: false,
        configurable: true
    });
    Query.prototype.find = function (entities) {
        if (entities === void 0) { entities = this._entityManager.entities; }
        return entities.find(this._filter);
    };
    Query.prototype.filter = function (entities) {
        if (entities === void 0) { entities = this._entityManager.entities; }
        return entities.filter(this._filter);
    };
    Query.prototype.map = function (callback, entities) {
        if (entities === void 0) { entities = this.filter(); }
        return entities.map(function (entity) {
            return callback(entity);
        });
    };
    Query.prototype.foreach = function (callback, entities) {
        var _this = this;
        if (entities === void 0) { entities = this.filter(); }
        entities.forEach(function (entity) {
            if (_this._filter(entity)) {
                callback(entity);
            }
        });
    };
    Query.prototype.matches = function (entity) {
        return this._filter(entity);
    };
    Query.prototype.matchesAll = function (entities) {
        return entities.every(this._filter);
    };
    Query.prototype.matchesAny = function (entities) {
        return entities.some(this._filter);
    };
    Query.prototype.matchesNone = function (entities) {
        var _this = this;
        return entities.every(function (entity) { return !_this._filter(entity); });
    };
    Query.prototype.matchesOne = function (entities) {
        var _this = this;
        return entities.some(function (entity) { return _this._filter(entity); });
    };
    Query.prototype.matchesAllExcept = function (entities, except) {
        var _this = this;
        return entities.every(function (entity) { return entity !== except || !_this._filter(entity); });
    };
    Query.prototype.matchesAnyExcept = function (entities, except) {
        var _this = this;
        return entities.some(function (entity) { return entity !== except || _this._filter(entity); });
    };
    return Query;
}());
exports.Query = Query;
